export const Artwork = {
  id: {
    type: Number,
    label: 'ID',
    hidden: true
  },
  artistId: {
    type: Number,
    label: 'Artist ID',
    hidden: true
  },
  name: {
    type: String,
    label: 'Name'
  },
  description: {
    type: String,
    label: 'Description'
  },
  status: {
    type: Array,
    label: 'Status',
    values: ['DRAFT', 'PENDING', 'PUBLISHED'],
    default: 'DRAFT'
  },
  allowWholesale: {
    type: Boolean,
    label: 'Allow wholesale'
  },
  matureContent: {
    type: Boolean,
    label: 'Mature content'
  },
  published: {
    type: Date,
    label: 'Publish Date'
  }
}

export const Tag = {
  id: {
    type: Number,
    label: 'ID',
    hidden: true
  },
  name: {
    type: String,
    label: 'Name'
  }
}

export const Sale = {
  vendorName: {
    type: String,
    label: 'Vendor name'
  },
  vendorEmail: {
    type: String,
    label: 'Vendor email'
  },
  orderId: {
    type: Number,
    label: 'Order ID'
  },
  orderStatus: {
    type: Array,
    label: 'Status',
    values: ['PENDING', 'PARTIAL', 'FULFILLED'],
    default: 'FULFILLED'
  },
  orderClosedDate: {
    type: Date,
    label: 'Date'
  },
  artworkId: {
    type: Number,
    label: 'Artwork ID'
  },
  artworkName: {
    type: String,
    label: 'Artwork name'
  },
  productSku: {
    type: String,
    label: 'Product SKU'
  },
  productQuantity: {
    type: Number,
    label: 'Quantity'
  },
  productPrice: {
    type: Number,
    label: 'Price'
  },
  commission: {
    type: Number,
    label: 'Commission'
  }
}



// WEBPACK FOOTER //
// ./src/api/entity-schema.js